export default "__VITE_ASSET__0a969e02__"